// @ts-nocheck
function show(id) {
  document.getElementById('welcome').style.display = 'none';
  document.querySelectorAll('.detail').forEach(d => d.classList.remove('visible'));
  const panel = document.getElementById('detail-' + id);
  if (panel) panel.classList.add('visible');
  document.querySelectorAll('.schema-btn').forEach(b => b.classList.remove('active'));
  const btn = document.querySelector('[data-schema="' + id + '"]');
  if (btn) btn.classList.add('active');
}

function switchTab(btn) {
  const tabsEl = btn.closest('.tabs');
  const btns = Array.from(tabsEl.querySelectorAll('.tab-btn'));
  const idx = btns.indexOf(btn);
  btns.forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const section = btn.closest('.section');
  const contents = section.querySelectorAll('.tab-content');
  contents.forEach(c => c.classList.remove('active'));
  if (contents[idx]) contents[idx].classList.add('active');
}

function copyCode(btn) {
  const pre = btn.closest('.code-wrap').querySelector('pre');
  navigator.clipboard.writeText(pre.innerText).then(() => {
    btn.textContent = 'Copied!';
    btn.classList.add('copied');
    setTimeout(() => { btn.textContent = 'Copy'; btn.classList.remove('copied'); }, 2000);
  });
}

// Shopify's blog editor strips inline onclick handlers from the saved article body,
// so bind interactions via event delegation off the attributes that do survive.
document.addEventListener('click', function (e) {
  const schemaBtn = e.target.closest('.schema-btn');
  if (schemaBtn && schemaBtn.dataset.schema) { show(schemaBtn.dataset.schema); return; }
  const tabBtn = e.target.closest('.tab-btn');
  if (tabBtn) { switchTab(tabBtn); return; }
  const copyBtn = e.target.closest('.copy-btn');
  if (copyBtn) { copyCode(copyBtn); }
});
